module.exports = __webpack_public_path__ + "static/media/System_Boundary-partitions.8f81de66.png";